export const environment = {
  production: false,
  hmr: false,
  application: {
    name: 'ParkSmart',
  },
  oAuthConfig: {
    issuer: 'https://localhost:44304/identity-api',
    clientId: 'Amaxa_App',
    dummyClientSecret: '1q2w3e*',
    scope: 'Amaxa',
    showDebugInformation: true,
    oidc: false,
    requireHttps: true,
  },
  apis: {
    default: {
      url: 'https://localhost:44375/internal-api',
    },
  },
  localization: {
    defaultResourceName: 'Amaxa',
  },
};
